module.exports = __webpack_public_path__ + "img/user.0fcac86c.svg";